import React from "react";

interface PinInputProps {
  value: string;
  length?: number;
  onChange: (val: string) => void;
  onComplete?: (val: string) => void;
}

export const PinInput: React.FC<PinInputProps> = ({ value, length = 4, onChange, onComplete }) => {
  React.useEffect(() => {
    if (value.length === length && onComplete) {
      onComplete(value);
    }
  }, [value, length, onComplete]);

  return (
    <div className="flex justify-center gap-4 my-6">
      {Array.from({ length }).map((_, i) => (
        <div
          key={i}
          className={`w-6 h-6 rounded-full transition-colors
            ${i < value.length ? 'bg-blue-600' : 'bg-gray-200'}`}
        />
      ))}
    </div>
  );
}; 